import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LangProvider } from './context/langcontext'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LangProvider>   {/* ✅ wrap App with global language provider */}
      <App />
    </LangProvider>
  </React.StrictMode>
);
